import angular, { IScope } from 'angular'

import { STATES } from '../../../../lib/routes'
import { QuickKeysManager } from '../../managers/quick-keys-manager'
import { $state, $q } from '../../ng-compat/imports'

class QuickKeysCtrl {
  public initialised: $TSFixMe
  public layoutDataAdaptor: $TSFixMe
  public quickKeyLayout: $TSFixMe
  public quickKeysSetupInProgress: $TSFixMe

  constructor(
    private $scope: IScope,
    public quickKeysManager: QuickKeysManager,
    private userSwitchingService: $TSFixMe
  ) {
    'ngInject'
    this.quickKeysManager.init().then(() => {
      this.layoutDataAdaptor = this.quickKeysManager.createLayoutDataAdaptor()
      this.quickKeysManager.on('quickKeyLayoutChange', this._setLayout, this)
      this.$scope.$on('$destroy', () => {
        this.quickKeysManager.off('quickKeyLayoutChange', this._setLayout)
      })
      this._setLayout()
    })
  }

  /**
   * Set the quick key layout (of the currently active register) to render.
   *
   * @private
   * @method _setLayout
   */
  private _setLayout() {
    this.$scope.$applyAsync(() => {
      this.quickKeysSetupInProgress = false
      this.quickKeyLayout = this.quickKeysManager.quickKeyLayout
      this.initialised = true
    })
  }

  /**
   * Set up quick keys for this register by navigating to quick key layout settings page (or add new layout page if
   * there are no existing button layouts to choose from).
   *
   * @method setUpQuickKeys
   */
  public setUpQuickKeys() {
    this.quickKeysSetupInProgress = true
    this._retailerHasQuickKeyLayouts().then(hasQuickKeyLayouts => {
      if (hasQuickKeyLayouts) {
        $state.go(STATES.SETTINGS)
      } else {
        this.quickKeysManager
          .createLayout(this.quickKeysManager.defaultNewLayoutName)
          .then(
            quickKeyLayout =>
              this.quickKeysManager.navigateToEditState(quickKeyLayout, true),
            () => {
              this.quickKeysSetupInProgress = false
            }
          )
      }
    })
  }

  /**
   * Open the switch user modal so a manager/admin can log in to set up quick keys.
   *
   * @method switchUser
   */
  public switchUser() {
    $q.when(this.userSwitchingService.selectUser()).catch(angular.noop)
  }

  /**
   * Determine whether a retailer has any quick key layouts
   *
   * @private
   * @method _retailerHasQuickKeyLayouts
   *
   * @return {Promise} Returns a promise when resolved will set hasQuickKeyLayouts to true or false
   */
  private _retailerHasQuickKeyLayouts() {
    return this.quickKeysManager
      .getAllQuickKeyLayouts()
      .then(layouts => Boolean(layouts.length))
  }
}

/**
 * Controller for the wr-quick-keys directive that renders the quick keys for the active register.
 *
 * @module webregister.controllers.wrQuickKeys
 */
angular
  .module('webregister.controllers')
  .controller('wrQuickKeysCtrl', QuickKeysCtrl)
